import { render, staticRenderFns } from "./naturalace.vue?vue&type=template&id=1778c798&scoped=true"
import script from "./naturalace.vue?vue&type=script&lang=js"
export * from "./naturalace.vue?vue&type=script&lang=js"
import style0 from "./naturalace.vue?vue&type=style&index=0&id=1778c798&prod&scoped=true&lang=css"
import style1 from "./naturalace.vue?vue&type=style&index=1&id=1778c798&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1778c798",
  null
  
)

export default component.exports